/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */
import * as api from '@/api/user';
import { USER } from '@/store/types';
import { finalizeAction } from '@/store/actions';
import { UserFull } from '@/api/types/user';

export interface StoreUserOtherState {
  user: UserFull;
}

export interface StoreUserOtherGetters {
  user: UserFull | null;
}

export default {
  namespaced: true,
  state: {
    user: null,
  },
  getters: {
    user: (state) => {
      if (state.user && Object.keys(state.user).length !== 0) {
        return state.user;
      }
      return null;
    },
  },
  actions: {
    [USER.GET_OTHER]({ state, commit }, { action: rawAction, reload, game, id, name, full, phone, silent }) {
      const action = finalizeAction(rawAction, state.game === game && state.id === id
        && state.name === name && state.full === full && state.phone === phone);
      if (action || reload) {
        return new Promise((resolve, reject) => {
          api.getPeek({
            game,
            id,
            name,
            full,
            phone,
            silent,
          }).then((res) => {
            commit(USER.GET_OTHER, {
              game,
              id,
              name,
              full,
              phone,
              user: res.data,
            });
            resolve();
          }).catch(reject);
        });
      }
      return Promise.resolve();
    },
    [USER.SET_PRISONER]({ dispatch }, params) {
      return new Promise((resolve, reject) => {
        api.setPrisoner(params.id, params.body).then(() => {
          dispatch(USER.GET_OTHER, { id: params.id, full: 'Y', reload: true });
          resolve();
        }).catch(reject);
      });
    },
  },
  mutations: {
    [USER.GET_OTHER](state, { game, id, name, full, phone, user }) {
      state.game = game;
      state.id = id;
      state.name = name;
      state.full = full;
      state.phone = phone;
      state.user = user;
    },
    [USER.CHANGE_ISFOLLOWED](state, value) {
      state.user.isFollowed = value;
    },
  },
};
